export const BOOKING_LABEL = "booking";
export const BOOKING_UNIQUE_ID_KEY = "booking_uuid";
